/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
/*global module require*/
"use strict";

var config = require("../../../shared/config"),
  URITemplate = require("../../../shared/uritemplate"),
  xhr = require("../../../client/xhr");
Object.assign = Object.assign || require("object-assign");
var nameExistsTemplateRG = new URITemplate("{+context}/setup/api/v2/toolchains?name={name}&resource_group_id={resource_group_id}");
module.exports = NameValidationJob;
function NameValidationJob() {
  this.timeoutId = null;
  this.idx = 0;
  this.initialize();
}
Object.assign(NameValidationJob.prototype, {
  initialize: function initialize() {},
  clear: function clear() {
    this.timeoutId = null;
  },
  cancel: function cancel() {
    /*globals window*/
    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId);
    }
    this.clear();
  },
  start: function start(value, resourceGroupId, callback) {
    /*globals document window*/
    var that = this;
    if (this.timeoutId) {
      this.cancel();
    }
    this.timeoutId = window.setTimeout(function () {
      that.clear();
      var url;
      if (resourceGroupId) {
        url = nameExistsTemplateRG.expand({
          context: config.CONTEXT_PATH,
          name: value,
          resource_group_id: resourceGroupId
        });
      } else {
        // no matches; this can happen if the account has no resource groups
        return callback(false);
      }
      xhr(url, {
        dataType: "json"
      }, function (error, result, xhr) {
        if (error) {
          callback({
            "status": "error",
            "description": error.description || error.message
          });
        } else {
          var match = result["items"].filter(function (item) {
            return item["name"] === value;
          });
          callback(match.length > 0);
        }
      });
    }, 500);
  }
});